import React from 'react';
import { Typography } from '@material-ui/core';
import { Section, SmSpace } from 'm2m.components';
import { ParticipanteResponse } from 'common/genericTypes';
import { addCpfCnpjMask } from 'utils/mask';
import { funcaoParticipanteDescriptions, tipoAcessoParticipanteDescriptions } from 'common/genericDescriptions';

interface Props {
  informacoesPrincipais: ParticipanteResponse;
}

export const InformacoesPrincipais: React.FC<Props> = (props) => {
  const { informacoesPrincipais } = props;

  return (
    <>
      <Section title={'Informações do Participante'} defaultGrid>
        <div>
          <Typography variant="body2">{'CNPJ Participante:'}</Typography>
          <Typography variant="body1">{addCpfCnpjMask(informacoesPrincipais.cnpj)}</Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Tipo de Acesso:'}</Typography>
          <Typography variant="body1">
            {tipoAcessoParticipanteDescriptions[informacoesPrincipais.tipoAcesso]}
          </Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Denominação ou Razão Social:'}</Typography>
          <Typography variant="body1">{informacoesPrincipais.razaoSocial}</Typography>
          <SmSpace />
        </div>
        {informacoesPrincipais.grupoEconomico && (
          <div>
            <Typography variant="body2">{'Grupo Econômico:'}</Typography>
            <Typography variant="body1">{informacoesPrincipais.grupoEconomico}</Typography>
            <SmSpace />
          </div>
        )}
        {informacoesPrincipais.inscricaoEstadual && (
          <div>
            <Typography variant="body2">{'Inscrição Estadual:'}</Typography>
            <Typography variant="body1">{informacoesPrincipais.inscricaoEstadual}</Typography>
            <SmSpace />
          </div>
        )}
        {informacoesPrincipais.inscricaoMunicipal && (
          <div>
            <Typography variant="body2">{'Inscrição Municipal:'}</Typography>
            <Typography variant="body1">{informacoesPrincipais.inscricaoMunicipal}</Typography>
            <SmSpace />
          </div>
        )}
        <div>
          <Typography variant="body2">{'Faturamento Médio Mensal:'}</Typography>
          <Typography variant="body1">{informacoesPrincipais.faturamentoMedioMensalUltimosDozeMeses}</Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Atividade Principal Desenvolvida:'}</Typography>
          <Typography variant="body1">{informacoesPrincipais.atividadePrincipalDesenvolvida}</Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Funções:'}</Typography>
          <Typography variant="body1">
            {informacoesPrincipais.funcoes.map((pf) => funcaoParticipanteDescriptions[pf.funcao]).join(', ')}
          </Typography>
          <SmSpace />
        </div>
      </Section>
      {(informacoesPrincipais.ispbBancoLiquidante ||
        informacoesPrincipais.razaoSocialBancoLiquidante ||
        informacoesPrincipais.agenciaBancoLiquidante ||
        informacoesPrincipais.contaBancoLiquidante) && (
          <Section title={'Dados Bancários'} defaultGrid>
            {informacoesPrincipais.ispbBancoLiquidante && (
              <div>
                <Typography variant="body2">{'ISPB:'}</Typography>
                <Typography variant="body1">{addCpfCnpjMask(informacoesPrincipais.ispbBancoLiquidante)}</Typography>
                <SmSpace />
              </div>
            )}
            {informacoesPrincipais.razaoSocialBancoLiquidante && (
              <div>
                <Typography variant="body2">{'Denominação ou Razão Social:'}</Typography>
                <Typography variant="body1">{informacoesPrincipais.razaoSocialBancoLiquidante}</Typography>
                <SmSpace />
              </div>
            )}
            {informacoesPrincipais.agenciaBancoLiquidante && (
              <div>
                <Typography variant="body2">{'Agência:'}</Typography>
                <Typography variant="body1">{informacoesPrincipais.agenciaBancoLiquidante}</Typography>
                <SmSpace />
              </div>
            )}
            {informacoesPrincipais.contaBancoLiquidante && (
              <div>
                <Typography variant="body2">{'Conta:'}</Typography>
                <Typography variant="body1">{informacoesPrincipais.contaBancoLiquidante}</Typography>
                <SmSpace />
              </div>
            )}
          </Section>
        )}
      <Section title={'Endereço e Contato'} defaultGrid>
        <div>
          <Typography variant="body2">{'CEP:'}</Typography>
          <Typography variant="body1">{informacoesPrincipais.cep}</Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Logadouro:'}</Typography>
          <Typography variant="body1">{informacoesPrincipais.logradouro}</Typography>
          <SmSpace />
        </div>
        {informacoesPrincipais.numero && <div>
          <Typography variant="body2">{'Número:'}</Typography>
          <Typography variant="body1">{informacoesPrincipais.numero}</Typography>
          <SmSpace />
        </div>}
        {informacoesPrincipais.complemento && (
          <div>
            <Typography variant="body2">{'Complemento:'}</Typography>
            <Typography variant="body1">{informacoesPrincipais.complemento}</Typography>
            <SmSpace />
          </div>
        )}
        <div>
          <Typography variant="body2">{'Bairro:'}</Typography>
          <Typography variant="body1">{informacoesPrincipais.bairro}</Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Cidade:'}</Typography>
          <Typography variant="body1">{informacoesPrincipais.cidade}</Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Unidade da Federação:'}</Typography>
          <Typography variant="body1">{informacoesPrincipais.uf}</Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Telefone:'}</Typography>
          {informacoesPrincipais.telefones?.map((t) => (
            <Typography variant="body1">{t}</Typography>
          ))}
          <SmSpace />
        </div>
      </Section>
    </>
  );
};

export default InformacoesPrincipais;
